export default __webpack_public_path__ + "static/122-60beae2d0915c7880cd9f1f828f37dca.jpg";